import { useLayoutStore, useLayoutStoreApi } from '@/workspace/layout-store/hooks'
import type { MosaicNode } from 'react-mosaic-component'
import type { WindowConfig } from './types'

/**
 * Layout state consumer hook.
 * Subscribes via Zustand selectors — only re-renders when layout state changes.
 */
export function useLayout() {
  const store = useLayoutStoreApi()
  const mosaicTree = useLayoutStore((s) => s.mosaicTree)
  const windowConfigs = useLayoutStore((s) => s.windowConfigs)
  const globalSettings = useLayoutStore((s) => s.globalSettings)
  const loaded = useLayoutStore((s) => s.layoutLoaded)
  const recoveryCount = useLayoutStore((s) => s.recoveryCount)

  return {
    mosaicTree,
    windowConfigs,
    globalSettings,
    loaded,
    recoveryCount,
    updateLayout: store.getState().updateLayout,
    updateWindowConfig: store.getState().updateWindowConfig,
  } as {
    mosaicTree: MosaicNode<string> | null
    windowConfigs: Record<string, WindowConfig>
    globalSettings: Record<string, unknown>
    loaded: boolean
    recoveryCount: number
    updateLayout: (
      tree: MosaicNode<string> | null,
      configs: Record<string, WindowConfig>,
      gs?: Record<string, unknown>,
    ) => void
    updateWindowConfig: (panelId: string, partial: Partial<WindowConfig>) => void
  }
}
